import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function Breadcrumb({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav
      data-testid="breadcrumb-nav"
      aria-label="Breadcrumb"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '.4rem',
        fontSize: '.78rem',
        color: 'var(--text2)',
        marginBottom: '1.25rem',
        flexWrap: 'wrap',
      }}
    >
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={item.label}>
            {i > 0 && (
              <ChevronRight size={11} style={{ color: 'var(--muted)', flexShrink: 0 }} />
            )}
            {isLast || !item.to ? (
              <span style={{ color: isLast ? 'var(--red)' : 'var(--text2)' }}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.to}
                style={{
                  color: 'var(--text2)',
                  textDecoration: 'none',
                  transition: 'color .2s',
                }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--blue)'}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--text2)'}
              >
                {item.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
